import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import * as Roles from 'app-models';
import { VIDEOS } from 'app-models';
import * as i1 from '@angular/router';
import * as i2 from '@angular/platform-browser';
import * as i3 from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import * as i4 from '@angular/common';
import * as i5 from 'primeng/tabview';
import { PrimengLibraryModule } from 'primeng-library';

class HelpVideoOverlayLibraryService {
    constructor() { }
}
HelpVideoOverlayLibraryService.ɵfac = function HelpVideoOverlayLibraryService_Factory(t) { return new (t || HelpVideoOverlayLibraryService)(); };
HelpVideoOverlayLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: HelpVideoOverlayLibraryService, factory: HelpVideoOverlayLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpVideoOverlayLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function HelpVideoOverlayLibraryComponent_2_ng_template_0_h5_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 17);
    i0.ɵɵelementStart(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.dialogHeader);
} }
function HelpVideoOverlayLibraryComponent_2_ng_template_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "iframe", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r4.videoLink, i0.ɵɵsanitizeResourceUrl)("title", ctx_r4.header);
} }
function HelpVideoOverlayLibraryComponent_2_ng_template_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p-tabView");
    i0.ɵɵelementStart(2, "p-tabPanel", 20);
    i0.ɵɵelement(3, "iframe", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-tabPanel", 20);
    i0.ɵɵelement(5, "iframe", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("header", ctx_r5.header);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r5.videoLink, i0.ɵɵsanitizeResourceUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("header", ctx_r5.header1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r5.videoLink1, i0.ɵɵsanitizeResourceUrl);
} }
function HelpVideoOverlayLibraryComponent_2_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtemplate(2, HelpVideoOverlayLibraryComponent_2_ng_template_0_h5_2_Template, 3, 1, "h5", 6);
    i0.ɵɵelementStart(3, "button", 7);
    i0.ɵɵlistener("click", function HelpVideoOverlayLibraryComponent_2_ng_template_0_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return ctx_r6.isOpen = false; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, HelpVideoOverlayLibraryComponent_2_ng_template_0_div_4_Template, 3, 2, "div", 8);
    i0.ɵɵtemplate(5, HelpVideoOverlayLibraryComponent_2_ng_template_0_div_5_Template, 6, 4, "div", 2);
    i0.ɵɵelement(6, "hr", 9);
    i0.ɵɵelementStart(7, "div", 10);
    i0.ɵɵelementStart(8, "div", 11);
    i0.ɵɵelementStart(9, "h6", 12);
    i0.ɵɵelementStart(10, "strong");
    i0.ɵɵtext(11, "Assistance at any time:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "a", 13);
    i0.ɵɵlistener("click", function HelpVideoOverlayLibraryComponent_2_ng_template_0_Template_a_click_12_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(2); return ctx_r8.routeToResourcePage(); });
    i0.ɵɵelement(13, "i", 14);
    i0.ɵɵtext(14, " Video Help ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "hr", 15);
    i0.ɵɵelementStart(16, "button", 16);
    i0.ɵɵlistener("click", function HelpVideoOverlayLibraryComponent_2_ng_template_0_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r7); const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.isOpen = false; });
    i0.ɵɵtext(17, "Dismiss");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.tabStructure);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.tabStructure);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.tabStructure);
} }
function HelpVideoOverlayLibraryComponent_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, HelpVideoOverlayLibraryComponent_2_ng_template_0_Template, 18, 3, "ng-template", 3);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("cdkConnectedOverlayOrigin", _r0)("cdkConnectedOverlayOpen", ctx_r1.isOpen);
} }
const _c0 = function (a0) { return { "left-position": a0 }; };
class HelpVideoOverlayLibraryComponent {
    constructor(router, sanitizer) {
        this.router = router;
        this.sanitizer = sanitizer;
        this.isOpen = false;
        this.tabStructure = false;
        this.videos = [];
        if (sessionStorage.getItem("userTypeRole") === Roles.ATTORNEY) {
            this.videos = VIDEOS.ATTORNEY_VIDEOS;
        }
        else if (sessionStorage.getItem("userTypeRole") === Roles.PETITIONER) {
            this.videos = VIDEOS.PETITIONER_VIDEOS;
        }
        else if (sessionStorage.getItem("userTypeRole") === Roles.BENEFICIARY) {
            this.videos = VIDEOS.BENEFICIARY_VIDEOS;
        }
    }
    ngOnInit() {
    }
    setValues(position, header, sectionName) {
        let link;
        this.position = position;
        this.header = header;
        link = this.findingVideoUrl(sectionName, '');
        if (link) {
            this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl(link.url);
        }
    }
    findingVideoUrl(sectionName, headerSectionName) {
        let linkObj;
        linkObj = this.videos.find((element) => element.sectionName === sectionName);
        if (!linkObj)
            this.videos.forEach((element) => {
                if (element.sectionName == headerSectionName && element.links && element.links.length > 0) {
                    linkObj = element.links.find((x) => x.sectionName === sectionName);
                    return linkObj;
                }
            });
        //console.log("link", linkObj);
        return linkObj;
    }
    setTabValues(position, dialogHeader, headerSectionName, sectionName, position1, header1, sectionName1) {
        let link1;
        let link2;
        this.dialogHeader = dialogHeader;
        this.position = position;
        this.header = headerSectionName;
        link1 = this.findingVideoUrl(sectionName, dialogHeader);
        this.videoLink = link1 ? this.sanitizer.bypassSecurityTrustResourceUrl(link1.url) : "";
        this.tabStructure = true;
        this.position1 = position1;
        this.header1 = header1;
        link2 = this.findingVideoUrl(sectionName1, dialogHeader);
        // link = this.videos.filter(x => x.sectionName == sectionName1);
        this.videoLink1 = link2 ? this.sanitizer.bypassSecurityTrustResourceUrl(link2.url) : "";
    }
    closeOverlay() {
        this.isOpen = !this.isOpen;
    }
    routeToResourcePage() {
        let resourceLink;
        let userType = sessionStorage.getItem("userTypeRole");
        if (userType == "Petitioner") {
            resourceLink = "/petitioner-landing/resources";
        }
        else if (userType == "Beneficiary") {
            resourceLink = "/beneficiary-landing/resources";
        }
        else if (userType == "Attorney") {
            resourceLink = "/attorney-landing/resources";
        }
        else if (userType == "I9Admin") {
            resourceLink = "/petitioner-landing/resources";
        }
        this.router.navigate([resourceLink]);
    }
}
HelpVideoOverlayLibraryComponent.ɵfac = function HelpVideoOverlayLibraryComponent_Factory(t) { return new (t || HelpVideoOverlayLibraryComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2.DomSanitizer)); };
HelpVideoOverlayLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: HelpVideoOverlayLibraryComponent, selectors: [["help-video-overlay-library"]], inputs: { inputDetails: "inputDetails", primaryData: "primaryData" }, decls: 3, vars: 4, consts: [["type", "button", "cdkOverlayOrigin", "", "mat-icon-button", "", "aria-label", "Help Video", 1, "video-button", 3, "ngClass", "click"], ["trigger", "cdkOverlayOrigin"], [4, "ngIf"], ["cdkConnectedOverlay", "", 3, "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen"], [1, "overlayContainer", "border", "p-3", "bg-white", "rounded", "shadow"], [1, ""], ["class", "mt-2", 4, "ngIf"], ["aria-label", "Close", 1, "icon-button", "position-absolute", "pi", "pi-times", 2, "top", "10px", "right", "10px", 3, "click"], ["class", "text-center", 4, "ngIf"], [1, "mb-0", "ml-1"], [1, "footer"], [1, "text-left"], [1, "d-inline-block", "mb-4"], [1, "back-button", "button-width-icon-left", "btn-pos-top-right", "btn", "button_whitebgImp", "float-right", 3, "click"], [1, "fa", "fa-question-circle"], [1, "mt-0", "ml-1"], [1, "link-button", "btn", 3, "click"], [1, "mt-2"], [1, "text-center"], ["width", "500", "height", "300", "frameborder", "0", "allow", "autoplay; fullscreen; picture-in-picture", "allowfullscreen", "", 3, "src", "title"], [3, "header"], ["width", "500", "height", "250", "frameborder", "0", "allow", "autoplay; fullscreen; picture-in-picture", "allowfullscreen", "", 3, "src"]], template: function HelpVideoOverlayLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0, 1);
        i0.ɵɵlistener("click", function HelpVideoOverlayLibraryComponent_Template_button_click_0_listener() { return ctx.isOpen = !ctx.isOpen; });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, HelpVideoOverlayLibraryComponent_2_Template, 1, 2, undefined, 2);
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, ctx.position === "left"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isOpen);
    } }, directives: [i3.CdkOverlayOrigin, i4.NgClass, i4.NgIf, i3.CdkConnectedOverlay, i5.TabView, i5.TabPanel], styles: [".video-button[_ngcontent-%COMP%]{border:0;background-color:transparent;position:absolute;background-image:url(../../../../assets/images/video_icon.svg);top:0;right:0;height:41px;width:48px;border-radius:0}.video-button.left-position[_ngcontent-%COMP%]{position:relative;top:-32px;left:14px;height:48px;width:52px;margin-bottom:-32px;background-image:url(../../../../assets/images/video_icon_left.svg)}a.back-button.button_whitebgImp[_ngcontent-%COMP%]{padding-top:10px!important}.overlayContainer[_ngcontent-%COMP%]{height:500px;border:1px solid #e1e1e1;width:600px;background:#fff;padding:10px}[_nghost-%COMP%]     .mat-tab-label{font-size:22px;line-height:32px;font-family:Source Sans Pro}[_nghost-%COMP%]     .mat-tab-label-active{border-color:#01a0da;color:#01a0da}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpVideoOverlayLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'help-video-overlay-library',
                templateUrl: './help-video-overlay-library.component.html',
                styleUrls: ['./help-video-overlay-library.component.scss']
            }]
    }], function () { return [{ type: i1.Router }, { type: i2.DomSanitizer }]; }, { inputDetails: [{
            type: Input
        }], primaryData: [{
            type: Input
        }] }); })();

class HelpVideoOverlayLibraryModule {
}
HelpVideoOverlayLibraryModule.ɵfac = function HelpVideoOverlayLibraryModule_Factory(t) { return new (t || HelpVideoOverlayLibraryModule)(); };
HelpVideoOverlayLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: HelpVideoOverlayLibraryModule });
HelpVideoOverlayLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            OverlayModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HelpVideoOverlayLibraryModule, { declarations: [HelpVideoOverlayLibraryComponent], imports: [PrimengLibraryModule,
        OverlayModule], exports: [HelpVideoOverlayLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpVideoOverlayLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [HelpVideoOverlayLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    OverlayModule
                ],
                exports: [HelpVideoOverlayLibraryComponent],
            }]
    }], null, null); })();

/*
 * Public API Surface of help-video-overlay-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { HelpVideoOverlayLibraryComponent, HelpVideoOverlayLibraryModule, HelpVideoOverlayLibraryService };
//# sourceMappingURL=help-video-overlay-library.js.map
